import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Dropdown from "components/forms/inputs/dropdown";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Modal from "components/layout/modal";
import { FormValues } from "lib/form";
import { ListEmailTemplate } from "models/list-email-template";
import { LocaleString } from "models/locale";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { faBolt } from "./icon-library";
import { useTranslate } from "stores/hooks/translation";

interface ImportEmailTemplateModalProps {
  emailTemplates: ListEmailTemplate[];
  preferredTemplateKey?: string; // not yet used, but can be user later
  onImport: (subject: LocaleString, message: LocaleString) => Promise<void>;
  onClose: () => Promise<void>;
}

const ImportEmailTemplateModal: FunctionComponent<
  ImportEmailTemplateModalProps
> = ({ emailTemplates, onImport, onClose }) => {
  const translate = useTranslate();

  const schema = yup
    .object({
      templateUuid: yup.string().validateRequired(),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { templateUuid: emailTemplates[0].uuid },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, postIcon: faBolt, text: "Valitse" },
  ];

  const handleSubmit = async (formValues: FormValues) => {
    const { templateUuid } = formValues;

    const template = emailTemplates.find((t) => t.uuid === templateUuid);
    if (template) {
      await onImport(template.subject, template.message);
      onClose();
    }
  };

  const options: OptionInterface[] = emailTemplates.map((et) => {
    return {
      value: et.uuid,
      text: translate(`email_template_type_${et.type}`),
    };
  });

  return (
    <Modal title="Valitse sähköpostimalli">
      <Form methods={methods} onSubmit={handleSubmit}>
        <Grid>
          <Row>
            <Col>
              <Dropdown
                name="templateUuid"
                label="Sähköpostimalli"
                options={options}
              />
            </Col>
          </Row>
        </Grid>
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default ImportEmailTemplateModal;
